import React from "react";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import { observer } from "mobx-react";

const styles = theme => ({
  input: {
    fontSize: "inherit",
    flexShrink: 0
  },
  selectRoot: {
    marginRight: theme.spacing(4),
    marginLeft: theme.spacing(1),
    color: theme.palette.text.secondary
  },
  select: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(3)
  },
  selectIcon: {
    top: 1
  },
  caption: {
    flexShrink: 0
  },
  sortByLabel: {
    margin: 0,
    position: "relative",
    top: "-1px",
    left: "5px",
    fontSize: "12px"
  }
});

class SortClipsDropdown extends React.Component {
  render() {
    const { classes, onChange, sortBy, sortByOptions } = this.props;
    return (
      <React.Fragment>
        <Typography className={`${classes.selectRoot} ${classes.sortByLabel}`}>
          Sort by:
        </Typography>
        <Select
          classes={{
            root: classes.selectRoot,
            select: classes.select,
            icon: classes.selectIcon
          }}
          input={<Input className={classes.input} disableUnderline />}
          value={sortBy.value}
          onChange={onChange}
        >
          {sortByOptions.map(option => (
            <MenuItem
              className={classes.menuItem}
              key={option.value}
              value={option.value}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(observer(SortClipsDropdown));



// WEBPACK FOOTER //
// ./src/components/SortClipsDropdown.js